import CustomDropDown from '@/utils/customDropDown';
import './index.scss';
import {
  Box,
  Button,
  HStack,
  Image,
  Radio,
  RadioGroup,
  Stack,
  Text
} from '@chakra-ui/react';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
  FilterGunType,
  FilterLicenseDetails,
  FilterLicenseType,
  FilterRatings,
  FilterReviews,
  RenderItems,
} from './Filters';
import { FilterButton } from './filterButtons';
import {
  getShowDropDown,
  getTransferFilterModel
} from '@/explore/ducks/selectors';
import {
  setLicenseByZipQueryParams,
  setShowDropdownSlice
} from '@/explore/ducks/slice';
import { useDispatch } from 'react-redux';
import { showDropdownEnum } from '@/model/explore';
import { FilterMode, keyType } from '@/queue/types';
import * as constants from '@/utils/constants';
import {
  StoreNameType,
  callToGetEcommerceStatus,
  callToGetAutoCompleteApiResult,
  callToGetSourceDescriptions,
  callToGetStoreNames,
  callToRemoveTransferFilters,
  callToUpdateTransferDetails,
  setEccomerceStatusFilterLists,

  setSourceDescriptionLists,
  setStoreNameLists,
  setTransferFilterModel,
  setSellerLicenseKeyLists,
  setAutoCompleteDataResult
} from '@/queue/ducks/slice';
import { IS_ARCHIVED, ONLY_MY_TRANSFER_LABEL } from '@/model/Constants';
import Select, { GroupBase, StylesConfig } from 'react-select';
import { getEcommerceStatusFilterLists, getEcommerceStatusLists, getIsRemoveTransferFiltersLoading, getIsTransferFiltersLoading, getSourceDescriptionLists, getSourceDescriptions, getStoreNameLists, getStoreNamesData, getAutoCompleteApiResult, getSellerLicenseKeyLists } from '@/queue/ducks/selectors';
import { getIsGlobalAdmin, getIsGlobalOperations, getIsImpersonating } from '@/redux/app-selectors';
import { DateValue } from 'react-aria';
import { filterDerivedValues, findMatchingTopLevelKey, isOutboundFilterDisabled } from '@/utils/utils';
import { debounce } from 'lodash';
import { getIsMultiTenantStore } from '@/storeAdmin/ducks/selectors';

// Guard so initial filter APIs run only once per mount (avoids double call from React Strict Mode in dev).
let hasInitialFilterFetchDone = false;

export default function FilterDropDown({
  isFiltersDisabled,
  filterMode,
  isInbound
}: {
  isFiltersDisabled: Boolean;
  filterMode?: FilterMode;
  isInbound?: boolean;
}) {
  const isGlobalAdmin = getIsGlobalAdmin();
  const isGlobalOperations = getIsGlobalOperations();
  const componentRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState<boolean>(false);
  const filterButtonRef = useRef<HTMLDivElement>(null);
  const transferFilterModel = getTransferFilterModel()
  const showDropdownSelector = getShowDropDown();
  const dispatch = useDispatch();
  function handleDropdown() {
    if (showDropdownSelector === showDropdownEnum.filters)
      dispatch(setShowDropdownSlice(null));
    else dispatch(setShowDropdownSlice(showDropdownEnum.filters));
  }
  const element = document.getElementById("filters");
  const maxHeight = element?.clientHeight || ((isGlobalAdmin || isGlobalOperations) ? 640 : 533)

  useEffect(() => {
    if (componentRef.current) {
      const element = componentRef.current;
      element.scrollHeight > maxHeight && (transferFilterModel?.storeName?.values.length>0 || transferFilterModel?.source?.values.length>0) ? setIsOverflowing(true) : setIsOverflowing(false);
    }
  }, [transferFilterModel?.storeName?.values,transferFilterModel?.source?.values]); 

  useEffect(() => {
    if (hasInitialFilterFetchDone) return;
    hasInitialFilterFetchDone = true;

    if (isGlobalAdmin || isGlobalOperations) {
      dispatch(callToGetStoreNames({}));
    }
    dispatch(callToGetSourceDescriptions({}));
    dispatch(callToGetEcommerceStatus({}));

    // Reset on unmount so filters refetch when user returns. Timeout ensures Strict Mode's
    // double-mount doesn't reset before the second effect run (so we still skip the duplicate).
    const timeoutId = setTimeout(() => {
      hasInitialFilterFetchDone = false;
    }, 0);
    return () => clearTimeout(timeoutId);
  }, [dispatch, isGlobalAdmin, isGlobalOperations]);
  const handleClickOutside = (event: any) => {
    const target = event.target as Element | null;
    // Saved-filters toolbar (Edit/Delete/Select): Chakra/SVG targets sometimes skip
    // filterButtonRef.contains(); keep the Filter By panel open.
    if (target?.closest?.('.transfer-multi-set-filter-wrapper-container')) {
      return;
    }
    if (
      filterButtonRef.current &&
      !filterButtonRef.current.contains(event.target)
    ) {
      dispatch(setShowDropdownSlice(null));
    }
  };

  return (
    <>
      <Box
        className={
          isFiltersDisabled
            ? 'filter-dropdown-box box-disabled'
            : 'filter-dropdown-box'
        }
        ref={filterButtonRef}
      >
        <HStack
          onClick={handleDropdown}
          cursor={'pointer'}
          className="custom-dropdown-button-wrapper"
        >
          <Box className="custom-dropdown-triangle" right={'50%'}></Box>
          <Button
            size={'sm'}
            backgroundColor={'#d7ebf9'}
            className="custom-dropdown-button"
          >
            <Image src={'/images/ui/filter.svg'}></Image>
          </Button>
          <Text fontSize={'18px'} lineHeight={'21.6px'}>
            Filter By
          </Text>
        </HStack>
        {showDropdownSelector === showDropdownEnum.filters && (
          <CustomDropDown
            children={
              filterMode === FilterMode.TRANSFER_FILTER ? (
                <Box id='filters' ref={componentRef} style={{height: (isGlobalAdmin || isGlobalOperations) ? 'fit-content' : 'fit-content',overflowY: 'auto'}} > <TransferFilters /></Box>
              ) : (
                <FilterDropDownChild />
              )
            }
            filterMode={filterMode}
            handleClickOutside={handleClickOutside}
            className={
              filterMode === FilterMode.TRANSFER_FILTER
                ? `transfer-filters-dropdown`
                : 'dealer-filters-dropdown'
            }
          />
        )}
      </Box>
    </>
  );
}

export const FilterDropDownChild = () => {
  const dispatch = useDispatch();
  function handleDefaultButton() {
    dispatch(setShowDropdownSlice(null));
  }

  function handleClearAll() {
    dispatch(
      setLicenseByZipQueryParams({
        sortBy: 'preferred'
      })
    );
  }
  return (
    <>
      <Box className="filters-header">
        <h3 className="filters-header__label">Filters</h3>
        <Button
          colorScheme="blue"
          onClick={handleClearAll}
          background="#ffffff"
          color="#0C1E46"
          border="1px solid #0C1E46"
          padding="5px 10px"
          borderRadius={'4px'}
          height="29px"
        >
          Clear All
        </Button>
      </Box>
      <Box className="filter-dropdown-child-wrapper-v2">
        <FilterLicenseType />
        <FilterGunType />
        <FilterLicenseDetails />
        <FilterRatings />
        <FilterReviews />
        <Box className="filter-dropdown-button-wrapper">
          <FilterButton
            handleClearAll={handleClearAll}
            handleDefaultButton={handleDefaultButton}
          />
        </Box>
      </Box>
      <Box className="filter-actions-mobiule-wrapper">
        <Button
          colorScheme="blue"
          onClick={handleDefaultButton}
          background="#ffffff"
          color="#0C1E46"
          border="1px solid #0C1E46"
          padding="8px 11px"
          marginRight="20px"
          borderRadius={'4px'}
        >
          CANCEL
        </Button>
        <Button
          colorScheme="blue"
          background="#0C1E46"
          padding="8px 20px"
          onClick={handleDefaultButton}
          borderRadius={'4px'}
        >
          SAVE AS DEFAULT
        </Button>
      </Box>
    </>
  );
};

export const TransferFilters = ({ isInbound = false }: { isInbound?: boolean }) => {
  const dispatch = useDispatch();
  const storeNames = getStoreNamesData();
  const sources = getSourceDescriptions();
  const transferFilterModel = getTransferFilterModel();
  const filterData = getStoreNameLists();
  const storeDescriptionData = getSourceDescriptionLists();
  const eccomerceStatusFilterList = getEcommerceStatusFilterLists();
  const ecommerceStatusData = getEcommerceStatusLists();
  const isGlobalAdmin = getIsGlobalAdmin();
  const isGlobalOperations = getIsGlobalOperations();
  const isImpersonating = getIsImpersonating();
  const isMultiTenantStore = getIsMultiTenantStore();
  const isLoading = getIsTransferFiltersLoading()
  const isRemoveFiltersLoading = getIsRemoveTransferFiltersLoading()
  const datePickerRef = useRef<any>(null);

  const [transferDateError, setTransferDateError] = useState('');
  const [storeFilterData, setStoreFilterData] = useState<any[]>([]);
  const [sourceFilterData, setSourceFilterData] = useState<any[]>([]);
  const [ecommerceFilterData, setEcommerceFilterData] = useState<any[]>([]);
  const [selectedOutboundFilter, setSelectedOutboundFilter] = useState<string>('all');
  const [outboundFilterOptions, setOutboundFilterOptions] = useState<any>({});
  const [sellerSearchValue, setSellerSearchValue] = useState<string>('');
  const autoCompleteData = getAutoCompleteApiResult();
  const sellerLicenseKeyLists = getSellerLicenseKeyLists();
  const [sellerFilterData, setSellerFilterData] = useState<any[]>([]);

  const findLabelByValue = (dataDetails: StoreNameType[], val: string) => {
    const result = dataDetails.find(data => data.value === val);
    return result ? result : null;
  }

  const defaultStoreNameValue = () => {
    let resArray: (StoreNameType | null)[] = [];
    transferFilterModel?.storeName?.values.map((value:any) => {
      const res = findLabelByValue(storeNames,value)
      resArray.push(res);
    })
    const defaultValues = resArray ?  resArray as StoreNameType[] : []
    dispatch(setStoreNameLists(defaultValues))
  }

  const debouncedSearch = useMemo(
    () => debounce((searchValue: string) => {
      if (searchValue.length > 1) {
        const encodedSearchValue = encodeURIComponent(searchValue);
        dispatch(callToGetAutoCompleteApiResult(encodedSearchValue));
      }
    }, 500), // 500ms delay
    [dispatch]
  )

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const defaultSourceNameValue = () => {
    let resArray: (StoreNameType | null)[] = [];
    transferFilterModel?.source?.values.map((value:any) => {
      const res = findLabelByValue(sources,value)
      resArray.push(res);
    })
    const defaultValues = resArray ?  resArray as StoreNameType[] : []
    dispatch(setSourceDescriptionLists(defaultValues));
  }
  const defaultEccomerceValue = () => {
    let resArray: (StoreNameType | null)[] = [];
    transferFilterModel?.ecommerce_status?.values.map((value:any) => {
      const res = findLabelByValue(ecommerceStatusData,value)
      resArray.push(res);
    })
    const defaultValues = resArray ?  resArray as StoreNameType[] : []
    dispatch(setEccomerceStatusFilterLists(defaultValues));
  }

  useEffect(() => {
    setStoreFilterData(filterData)
  }, [filterData])

  useEffect(() => {
    setSourceFilterData(storeDescriptionData)
  }, [storeDescriptionData])
  useEffect(() => {
    setEcommerceFilterData(eccomerceStatusFilterList)
  }, [eccomerceStatusFilterList])

  useEffect(() => {
    setSellerFilterData(sellerLicenseKeyLists);
  }, [sellerLicenseKeyLists])

  useEffect(() => {
    const isExcludeMode =
      transferFilterModel?.derivedStatus?.filterType === 'notEqual' ||
      transferFilterModel?.microStatus?.filterType === 'notEqual';

    if (
      transferFilterModel?.derivedStatus?.values &&
      transferFilterModel?.derivedStatus?.values.length > 0 &&
      !isExcludeMode
    ) {
      const selectedStatus = findMatchingTopLevelKey(
        transferFilterModel?.derivedStatus?.values,
        constants.transferMacroSubStatusV2
      );
      setSelectedOutboundFilter(selectedStatus);
      if (selectedStatus === 'all') {
        setOutboundFilterOptions({});
      } else {
        const subFilters = constants.transferMacroSubStatusV2[selectedStatus];
        setOutboundFilterOptions(subFilters);
      }
    } else {
      // Exclude mode and empty derived status should both reset outbound selector.
      setSelectedOutboundFilter('all');
      setOutboundFilterOptions({});
    }
    defaultStoreNameValue();
    defaultSourceNameValue();
    defaultEccomerceValue();
  }, [transferFilterModel])


  const handleChange = (selected: StoreNameType[]) => {
    dispatch(setStoreNameLists(selected));
    const selectValue = selected.map((obj) => obj.value);
    dispatch(
      setTransferFilterModel({
        ...transferFilterModel,
        storeName: { ...transferFilterModel.storeName, values: selectValue }
      })
    );
  };
  const handleSourceChange = (selected: StoreNameType[]) => {
    dispatch(setSourceDescriptionLists(selected));
    const selectValue = selected.map((obj) => obj.value);
    dispatch(
      setTransferFilterModel({
        ...transferFilterModel,
        source: { ...transferFilterModel.source, values: selectValue }
      })
    );
  };
  const handleEcommerceStatusChange = (selected: StoreNameType[]) => {
    dispatch(setEccomerceStatusFilterLists(selected));
    const selectValue = selected.map((obj) => obj.value);
    dispatch(
      setTransferFilterModel({
        ...transferFilterModel,
        ecommerce_status: { ...transferFilterModel.ecommerce_status,filterType: 'set', values: selectValue }
      })
    );
  };


  function handleOutboundStatus(value: string) {
    if (value === "all") {
      setSelectedOutboundFilter("all");
      setOutboundFilterOptions({});
    } else if (value) {
      setSelectedOutboundFilter(value);
      const subFilters = constants.transferMacroSubStatusV2[value];
      setOutboundFilterOptions(subFilters);
    }
    const updatedFilters = filterDerivedValues(
      transferFilterModel?.derivedStatus?.values || [],
      constants.transferMacroSubStatusV2
    )
    const derivedStatus = {
      derivedStatus: {
        filterType: 'set',
        values: [...updatedFilters, value],
      },
      microStatus: {
        ...transferFilterModel.microStatus,
        filterType: 'set',
        values: []
      },

    }
    dispatch(
      setTransferFilterModel({
        ...transferFilterModel,
        ...derivedStatus
      })
    );
  }
  const queryHandler = (isCurrentlyChecked: Boolean, value: string, filter?: string | null) => {
    if (Object.keys(outboundFilterOptions).includes(value)) {
      const transferMicroStatusList = !isCurrentlyChecked
        ? transferFilterModel.microStatus.values.includes(value)
          ? transferFilterModel.microStatus.values
          : [...transferFilterModel.microStatus.values, value]
        : transferFilterModel.microStatus.values.filter((item:any) => {
          if (value === "queue_status_dealer_changed") {
            return item !== value && item !== "dealer_selected";
          }
          return item !== value
        });
      if (transferMicroStatusList?.length && transferMicroStatusList.includes("queue_status_dealer_changed")) transferMicroStatusList.push("dealer_selected")
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          microStatus: {
            ...transferFilterModel.microStatus,
            filterType: 'set',
            values: transferMicroStatusList
          }
        })
      );
    } else if (Object.keys(constants.storeTypeFilters).includes(value)) {

      const storeTypeList = !isCurrentlyChecked
        ? transferFilterModel.is_external.values.includes(value)
          ? transferFilterModel.is_external.values
          : [...transferFilterModel.is_external.values, value]
        : transferFilterModel.is_external.values.filter(
          (status) => status !== value
        );
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          is_external: {
            ...transferFilterModel.is_external,
            values: storeTypeList
          }
        })
      );
    } else if (value === ONLY_MY_TRANSFER_LABEL) {
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          agent: {
            ...transferFilterModel.agent,
            values: !isCurrentlyChecked ? [ONLY_MY_TRANSFER_LABEL] : []
          }
        })
      );
    } else if (Object.keys(constants.firearmType).includes(value)) {
      const firearmTypeList = !isCurrentlyChecked
        ? transferFilterModel.firearm.values.includes(value)
          ? transferFilterModel.firearm.values
          : [...transferFilterModel.firearm.values, value]
        : transferFilterModel.firearm.values.filter(
          (status) => status !== value
        )
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          firearm: {
            ...transferFilterModel.firearm,
            values: firearmTypeList
          }
        })
      )
    } else if (Object.keys(constants.EXCLUDE_TRANSFER_FILTERS).includes(value)) {
      const excludeMacroStatusFromTransferList = !isCurrentlyChecked
        ? transferFilterModel.derivedStatus.values.includes(value)
          ? transferFilterModel.derivedStatus.values
          : [...transferFilterModel.derivedStatus.values, value]
        : transferFilterModel.derivedStatus.values.filter(
          (status) => status !== value
        )
      const excludeMicroStatusFromTransferList = !isCurrentlyChecked ?
        transferFilterModel.microStatus.values.includes(value)
          ? transferFilterModel.microStatus.values
          : [...transferFilterModel.microStatus.values, value]
        : transferFilterModel.microStatus.values.filter(
          (status) => status !== value
        )

      const macroStatusfilteredValues = excludeMacroStatusFromTransferList.filter((f: any) => f !== 'all');
      const microStatusfilteredValues = excludeMicroStatusFromTransferList.filter((f: any) => f !== 'all');
      /** Checking an exclude option: clear store / source / e-commerce so dropdowns match the new filter mode. */
      const clearStoreSourceEcommerce = !isCurrentlyChecked
        ? {
            storeName: {
              ...transferFilterModel.storeName,
              filterType: 'set',
              values: []
            },
            source: {
              ...transferFilterModel.source,
              filterType: 'set',
              values: []
            },
            ecommerce_status: {
              ...transferFilterModel.ecommerce_status,
              filterType: 'set',
              values: []
            }
          }
        : {};
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          ...clearStoreSourceEcommerce,
          ...((value === 'tranfer_pending' || value === 'outbound_transfer_complete')? {
            derivedStatus: {
              filterType: 'notEqual',
              values: macroStatusfilteredValues,
            },
          } : {}),
          ...(value === 'queue_status_first_time_confirmation_delay' ? {
            microStatus: {
              filterType: 'notEqual',
              values: microStatusfilteredValues,
            },
          } : {}),
        })
      );
      if (!isCurrentlyChecked) {
        dispatch(setStoreNameLists([]));
        dispatch(setSourceDescriptionLists([]));
        dispatch(setEccomerceStatusFilterLists([]));
      }
    }

    // else if (Object.keys(constants.transferMicrostatus).includes(value)) { 
    //   const transferMicroStatusList = !isCurrentlyChecked
    //     ? transferFilterModel.microStatus.values.includes(value)
    //       ? transferFilterModel.microStatus.values
    //       : [...transferFilterModel.microStatus.values, value]
    //     : transferFilterModel.microStatus.values.filter(
    //       (status) => status !== value
    //     );
    //   dispatch(
    //     setTransferFilterModel({
    //       ...transferFilterModel,
    //       microStatus: {
    //         ...transferFilterModel.microStatus,
    //         values: transferMicroStatusList
    //       }
    //     })
    //   );
    // }
    else if (Object.keys(constants.transferType).includes(value)) {
      const transferTypeList = !isCurrentlyChecked
        ? transferFilterModel.transferType.values.includes(value)
          ? transferFilterModel.transferType.values
          : [...transferFilterModel.transferType.values, value]
        : transferFilterModel.transferType.values.filter(
          (status) => status !== value
        );
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          transferType: {
            ...transferFilterModel.transferType,
            values: transferTypeList
          }
        })
      );
    } else if (Object.keys(constants.sellerLicenseKeyFilter).includes(value)) {
      const currentValues = (transferFilterModel.sellerLicenseKey as any)?.values || [];
      const sellerLicenseKeyList = !isCurrentlyChecked
        ? currentValues.includes(value)
          ? currentValues
          : [...currentValues, value]
        : currentValues.filter(
          (status: string) => status !== value
        );
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          sellerLicenseKey: {
            ...(transferFilterModel.sellerLicenseKey as any || {}),
            filterType: 'set',
            values: sellerLicenseKeyList
          }
        })
      );
    } else if (Object.keys(constants.sellerLicenseKeyFilter).includes(value) || Object.keys(constants.transferTypeFilter).includes(value)) {
      const currentValues = (transferFilterModel.sellerLicenseKey as any)?.values || [];
      const sellerLicenseKeyList = !isCurrentlyChecked
        ? currentValues.includes(value)
          ? currentValues
          : [...currentValues, value]
        : currentValues.filter(
          (status: string) => status !== value
        );
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          sellerLicenseKey: {
            ...(transferFilterModel.sellerLicenseKey as any || {}),
            filterType: 'set',
            values: sellerLicenseKeyList
          }
        })
      );
    }else if (value === IS_ARCHIVED) {
      dispatch(
        setTransferFilterModel({
          ...transferFilterModel,
          isArchive: {
            ...transferFilterModel.isArchive,
            values: !isCurrentlyChecked ? ["true"] : []
          }
        })
      );
    }
  };

  const selectStyles: StylesConfig<
    StoreNameType,
    true,
    GroupBase<StoreNameType>
  > = {
    menuList: (styles) => ({
      ...styles,
      maxHeight: '170px'
    }),
    valueContainer: (styles) => ({
      ...styles,
      maxHeight: '150px',
      overflowY: 'auto'
    })
  };

  const getAllOutboundTransferStatus = useMemo(() => {
    const {
      inbound_transfer_pending,
      inbound_transfer_awaiting_item,
      inbound_transfer_complete,
      inbound_transfer_failed,
      inbound_transfer_item_received,
      ...rest
    } = constants.transferMacrostatus;
    return rest;
  }, []);
  enum TransferDateFieldEnum {
    dateFrom = 'dateFrom',
    dateTo = 'dateTo'
  }
  const onChangeTransferDate = (fieldName: TransferDateFieldEnum | null) => {
    return (value: DateValue | null) => {
      if (!value) return;
      if (fieldName) {
        const date = `${value.year}-${value.month}-${value.day}`;
        dispatch(
          setTransferFilterModel({
            ...transferFilterModel,
            createdAt: {
              ...transferFilterModel.createdAt,
              [fieldName]: date
            }
          })
        );
      }
    };
  };

  const onChangeTransferStartDate = onChangeTransferDate(
    TransferDateFieldEnum.dateFrom
  );
  const onChangeTransferEndDate = onChangeTransferDate(
    TransferDateFieldEnum.dateTo
  );

  const onRestTransferDate = () => {
    dispatch(
      setTransferFilterModel({
        ...transferFilterModel,
        createdAt: {
          ...transferFilterModel.createdAt,
          dateFrom: null,
          dateTo: null
        }
      })
    );
  };

  useEffect(() => {
    if (
      transferFilterModel.createdAt.dateFrom &&
      transferFilterModel.createdAt.dateTo &&
      new Date(transferFilterModel.createdAt.dateFrom) >
      new Date(transferFilterModel.createdAt.dateTo)
    ) {
      setTransferDateError(constants.INVALID_RANGE);
    } else {
      if (
        (!transferFilterModel.createdAt.dateFrom &&
          !transferFilterModel.createdAt.dateTo) ||
        (transferFilterModel.createdAt.dateFrom &&
          transferFilterModel.createdAt.dateTo)
      ) {
        setTransferDateError('');
      } else {
        setTransferDateError(
          constants.SELECT_FIELD_DATE.replace(
            '{{field}}',
            !transferFilterModel.createdAt.dateFrom ? 'start' : 'end'
          )
        );
      }
    }
  }, [JSON.stringify(transferFilterModel.createdAt)]);

  // const clearAllFilters = () => {
  //   onRestTransferDate();
  //   dispatch(setTransferFilterModel({
  //     ...transferFilterModel,
  //     storeName: { ...transferFilterModel.storeName, values: [] },
  //     source: { ...transferFilterModel.source, values: [] },
  //     transferType: { ...transferFilterModel.transferType, values: [] },
  //     derivedStatus: { ...transferFilterModel.derivedStatus, values: [] },
  //     microStatus: { ...transferFilterModel.microStatus, values: [] },
  //     agent: { ...transferFilterModel.agent, values: [] },
  //     firearm: { ...transferFilterModel.firearm, values: [] },
  //     isArchive: { ...transferFilterModel.isArchive, values: [] },
  //     createdAt: { ...transferFilterModel.createdAt, dateFrom: null, dateTo: null },
  //   }));
  //   dispatch(setStoreNameLists([]));
  //   dispatch(setSourceDescriptionLists([]));
  // }
  const onSaveHandler = () => {
    dispatch(callToUpdateTransferDetails({filters: transferFilterModel}))
  }

  const onChangeSellerSearchHandler = (inputValue: string) => {
    setSellerSearchValue(inputValue);
    if (inputValue.length === 0) {
      dispatch(setAutoCompleteDataResult([]));
    } else {
      debouncedSearch(inputValue);
    }
  };

  const handleSellerSelect = (selected: any) => {
    if (selected && selected.length > 0) {
      const selectValue = selected.map((obj: any) => obj.shortLicenseNumber);
      dispatch(setSellerLicenseKeyLists(selected));
      
      const updatedFilterModel = {
        ...transferFilterModel,
        sellerLicenseKey: {
          ...(transferFilterModel.sellerLicenseKey as any || {}),
          filterType: 'set',
          values: selectValue
        }
      };
      
      dispatch(setTransferFilterModel(updatedFilterModel));
    } else {
      // Handle deselection (when all are removed)
      dispatch(setSellerLicenseKeyLists([]));
      
      const updatedFilterModel = {
        ...transferFilterModel,
        sellerLicenseKey: {
          ...(transferFilterModel.sellerLicenseKey as any || {}),
          filterType: 'set',
          values: []
        }
      };
      
      dispatch(setTransferFilterModel(updatedFilterModel));
    }
  };

  // Transform autocomplete data to react-select options format
  const sellerOptions = useMemo(() => {
    return autoCompleteData.map((item) => ({
      ...item,
      label: item.businessName,
      value: item.shortLicenseNumber,
    }));
  }, [autoCompleteData]);

  return (
    <>
      <Box
        className={`filter-dropdown-child-wrapper-v2 ${'transfer-filters-select'}`}
      >
        <div className="transfer-filters__vertical types-wrapper">

          <Box className="license-type-box-wrapper outbound-status-filter source-filter">
            <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
              {constants.ECOMMERCE_STATUS}
            </Text>
            <Box marginTop={'15px'}>
              <Select
                value={ecommerceFilterData}
                isMulti
                name="ecommerceStatus"
                options={ecommerceStatusData}
                className="muiltipleSelect"
                closeMenuOnSelect={false}
                styles={selectStyles}
                onChange={handleEcommerceStatusChange as () => void}
                components={{
                  Option: (props) => (
                    <div
                      className="select-option"
                      {...props.innerProps}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          props &&
                          props.innerProps &&
                          props.innerProps.onClick
                        ) {
                          props.innerProps.onClick(e);
                        }
                      }}
                    >
                      {props.children}
                    </div>
                  )
                }}
              />
            </Box>
          </Box>
          <Box className="license-type-box-wrapper outbound-status-filter source-filter">
            <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
              {constants.SOURCE_DESCRIPTION}
            </Text>
            <Box marginTop={'15px'}>
              <Select
                value={sourceFilterData}
                isMulti
                name="sourceDescription"
                options={sources}
                className="muiltipleSelect"
                closeMenuOnSelect={false}
                styles={selectStyles}
                onChange={handleSourceChange as () => void}
                components={{
                  Option: (props) => (
                    <div
                      className="select-option"
                      {...props.innerProps}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (
                          props &&
                          props.innerProps &&
                          props.innerProps.onClick
                        ) {
                          props.innerProps.onClick(e);
                        }
                      }}
                    >
                      {props.children}
                    </div>
                  )
                }}
              />
            </Box>
          </Box>
          {(isGlobalAdmin || isGlobalOperations) && (
            <>
              <Box className="license-type-box-wrapper">
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                  {constants.STORE_NAME}
                </Text>
                <Box marginTop={'15px'}>
                  <Select
                    value={storeFilterData}
                    isMulti
                    name="storeName"
                    options={storeNames}
                    className="muiltipleSelect"
                    closeMenuOnSelect={false}
                    styles={selectStyles}
                    onChange={handleChange as () => void}
                    components={{
                      Option: (props) => (
                        <div
                          className="select-option"
                          {...props.innerProps}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (
                              props &&
                              props.innerProps &&
                              props.innerProps.onClick
                            ) {
                              props.innerProps.onClick(e);
                            }
                          }}
                        >
                          {props.children}
                        </div>
                      )
                    }}
                  />
                </Box>
              </Box>
              <Box className="license-type-box-wrapper outbound-status-filter" sx={{ marginLeft: 0 }}>
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                  {constants.STORE_TYPE_LABEL}
                </Text>
                <Box marginTop={'15px'}>
                  {Object.keys(constants.storeTypeFilters).map(
                    (ele: string, index: number) => {
                      return (
                        <RenderItems
                          key={index}
                          label={ele === "true" ? "Live" : "Testing"}
                          item={
                            constants.storeTypeFilters[
                            ele as keyType<typeof constants.storeTypeFilters>
                            ]
                          }
                          value={ele}
                          index={index}
                          handler={queryHandler}
                          checked={
                            transferFilterModel?.is_external?.values?.length > 0
                              ? transferFilterModel?.is_external?.values?.includes(ele)
                              : false
                          }
                        />
                      );
                    }
                  )}

                </Box>
              </Box>
            </>
          )}

        </div>
        <div className="transfer-filters__vertical transfer-filters_status">
           {( isGlobalAdmin || isMultiTenantStore || isGlobalOperations)  && 
              <Box className="license-type-box-wrapper">
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                  {constants.SEARCH_SELLER}
                </Text>
              
                <Box marginTop={'15px'}>
                  <Select
                    value={sellerFilterData}
                    isMulti
                    name="sellerSearch"
                    options={sellerOptions}
                    className="muiltipleSelect"
                    placeholder="Search..."
                    onInputChange={onChangeSellerSearchHandler}
                    onChange={handleSellerSelect}
                    isSearchable
                    closeMenuOnSelect={false}
                    filterOption={() => true}
                    menuIsOpen={sellerSearchValue.length >= 1 && sellerOptions.length > 0}
                    styles={selectStyles}
                    components={{
                      DropdownIndicator: () => null,
                      IndicatorSeparator: () => null,
                      Option: (props: any) => {
                        const data = props.data;
                        return (
                          <div
                            className="select-option"
                            {...props.innerProps}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (
                                props &&
                                props.innerProps &&
                                props.innerProps.onClick
                              ) {
                                props.innerProps.onClick(e);
                              }
                            }}
                          >
                            <Box>
                              <Text fontSize={'14px'} fontWeight={600} lineHeight={'16.8px'}>
                                {data.businessName}
                              </Text>
                              <Text fontSize={'12px'} lineHeight={'14.4px'} color={'#666'}>
                                {data.shortLicenseNumberWithHyphen} • {data.city}, {data.state}
                              </Text>
                            </Box>
                          </div>
                        );
                      }
                    }}
                  />
                </Box>
           </Box>} 
           {/* {(isGlobalAdmin && isMultiTenantStore) && 
            <Box className="license-type-box-wrapper">
              <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                {constants.SEARCH_SELLER}
              </Text>
              <Box marginTop={'15px'}>
                  {Object.keys(constants.transferTypeFilter).map(
                    (ele: string, index: number) => {
                      return (
                        <RenderItems
                          key={index}
                          item={
                            constants.transferTypeFilter[
                            ele as keyType<typeof constants.transferTypeFilter>
                            ]
                          }
                          value={ele}
                          index={index}
                          handler={queryHandler}
                          checked={
                            (transferFilterModel.sellerLicenseKey as any)?.values?.length > 0
                              ? (transferFilterModel.sellerLicenseKey as any).values.includes(ele)
                              : false
                          }
                        />
                      );
                    }
                  )}

                </Box>
            </Box>} */}
            <Box className="license-type-box-wrapper">
              <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                {constants.TRANSFER_TYPE}
              </Text>

              <Box marginTop={'15px'}>
                {Object.keys(constants.sellerLicenseKeyFilter).map(
                  (ele: string, index: number) => {
                    return (
                      <RenderItems
                        key={index}
                        item={
                          constants.sellerLicenseKeyFilter[
                            ele as keyType<typeof constants.sellerLicenseKeyFilter>
                          ]
                        }
                        value={ele}
                        index={index}
                        handler={queryHandler}
                        checked={
                          (transferFilterModel.sellerLicenseKey as any)?.values?.length > 0
                            ? (transferFilterModel.sellerLicenseKey as any).values.includes(ele)
                            : false
                        }
                      />
                    );
                  }
                )}
              </Box>
            </Box>

        </div>
        <div className="transfer-filters__vertical transfer-filters_status">

          <Box className="license-type-box-wrapper">
            <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
              {constants.FIREARM_TYPE}
            </Text>
            <Box marginTop={'15px'}>
              {Object.keys(constants.firearmType).map(
                (ele: string, index: number) => {
                  return (
                    <RenderItems
                      item={
                        constants.firearmType[
                        ele as keyType<typeof constants.firearmType>
                        ]
                      }
                      value={ele}
                      index={index}
                      handler={queryHandler}
                      checked={
                        transferFilterModel?.firearm?.values?.length > 0
                          ? transferFilterModel?.firearm?.values?.includes(ele)
                          : false
                      }
                    />
                  );
                }
              )}
            </Box>
          </Box>

          <Box className="license-type-box-wrapper">
            <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
              {constants.AGENT}
            </Text>
            <Box marginTop={'15px'}>
              <Box>
                <RenderItems
                  item={ONLY_MY_TRANSFER_LABEL}
                  index={1}
                  handler={queryHandler}
                  checked={
                    transferFilterModel.agent.values.length > 0
                      ? transferFilterModel.agent.values.includes(
                        ONLY_MY_TRANSFER_LABEL
                      )
                      : false
                  }
                />
              </Box>
            </Box>
          </Box>

          {/* {!isGlobalAdmin && !isGlobalOperations && (
            <Box className="license-type-box-wrapper">
              <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                {constants.LINKED_TRANSFERS}
              </Text>
              <Box marginTop={'15px'}>
                <RadioGroup
                  value={transferFilterModel?.linkedTransfers?.values?.[0] || 'all'}
                  onChange={(value: string) => {
                    dispatch(
                      setTransferFilterModel({
                        ...transferFilterModel,
                        linkedTransfers: {
                          ...transferFilterModel.linkedTransfers,
                          filterType: 'set',
                          values: value === 'all' ? [] : [value]
                        }
                      })
                    );
                  }}
                >
                  <Stack spacing={2}>
                    {Object.keys(constants.linkedTransferFilter).map((key: string) => (
                      <Radio key={key} value={key}>
                        {constants.linkedTransferFilter[key as keyof typeof constants.linkedTransferFilter]}
                      </Radio>
                    ))}
                  </Stack>
                </RadioGroup>
              </Box>
            </Box>
          )} */}

          {(isGlobalAdmin || isGlobalOperations) && (
            <Box className="license-type-box-wrapper outbound-status-filter source-filter" sx={{paddingLeft: 0}}>
              <Box className="license-type-box-wrapper license-type" >
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                  {constants.ARCHIVE}
                </Text>
                <Box marginTop={'15px'}>
                  <Box>
                    <RenderItems
                      item={IS_ARCHIVED}
                      index={1}
                      handler={queryHandler}
                      checked={
                        transferFilterModel.isArchive.values.length > 0
                          ? transferFilterModel.isArchive.values.includes(
                            "true"
                          )
                          : false
                      }
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          )}
        </div>

        {!isInbound && (
          <>
            <div className="transfer-filters__vertical transfer-filters_status">
              {/* <Box className="license-type-box-wrapper inbound-status-filter-wrapper">
          <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
            {constants.INBOUND_STATUS}
          </Text>
          <Box marginTop={'15px'}>
            {Object.keys(constants.inboundMacrostatus).map(
              (ele: string, index: number) => {
                return (
                  <RenderItems
                    item={
                      constants.inboundMacrostatus[
                      ele as keyType<typeof constants.inboundMacrostatus>
                      ]
                    }
                    value={ele}
                    index={index}
                    handler={queryHandler}
                    checked={
                      transferFilterModel.derivedStatus.values.length > 0
                        ? transferFilterModel.derivedStatus.values.includes(ele)
                        : false
                    }
                  />
                );
              }
            )}
          </Box>
        </Box> */}
              <Box className="license-type-box-wrapper outbound-status-filter">
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                  {constants.OUTBOUND_STATUS}
                </Text>
                <Box marginTop={'15px'}>
                  <RadioGroup
                    onChange={handleOutboundStatus}
                    value={selectedOutboundFilter}
                  >
                    <Stack direction="column">
                      {Object.keys(constants.transferMacrostatusV2).map((ele: any, index: number) => (
                        <Box _hover={{ color: '#0090C6' }} key={index}>
                          <Radio isDisabled={isOutboundFilterDisabled(ele, transferFilterModel)} value={ele}>{constants.transferMacrostatusV2[ele]}</Radio>
                        </Box>
                      ))}
                    </Stack>
                  </RadioGroup>
                </Box>
              </Box>
            </div>
            <div className="transfer-filters__vertical">
              <Box className="license-type-box-wrapper outbound-status-filter-wrapper">
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                  {constants.OUTBOUND_SUB_STATUS}
                </Text>
                <Box marginTop={'15px'}>
                  {Object.keys(outboundFilterOptions).map(
                    (ele: string, index: number) => {
                      return (
                        <RenderItems
                          item={outboundFilterOptions[ele]}
                          value={ele}
                          index={index}
                          handler={queryHandler}
                          checked={
                            transferFilterModel.microStatus.values.length > 0
                              ? transferFilterModel.microStatus.values.includes(ele)
                              : false
                          }
                        />
                      );
                    }
                  )}
                </Box>
              </Box>

              <Box className="license-type-box-wrapper">
                <Text fontSize={'18px'} fontWeight={700} lineHeight={'21.6px'}>
                  {constants.PENDING_TRANSFER_NAME}
                </Text>
                <Box marginTop={'15px'}>
                  <Box>
                    {Object.keys(constants.EXCLUDE_TRANSFER_FILTERS).map(
                      (ele: string, index: number) => {
                        return (
                          <RenderItems
                            key={index}
                            item={
                              constants.EXCLUDE_TRANSFER_FILTERS[
                              ele as keyType<typeof constants.EXCLUDE_TRANSFER_FILTERS>
                              ]
                            }
                            index={1}
                            value={ele}
                            handler={queryHandler}
                            disabled={selectedOutboundFilter !== 'all'}
                            checked={
                              (transferFilterModel.derivedStatus.values.length > 0 && transferFilterModel.derivedStatus.filterType === 'notEqual'
                                ? transferFilterModel.derivedStatus.values.includes(ele)
                                : false) ||
                              (transferFilterModel.microStatus.values.length > 0 && transferFilterModel.microStatus.filterType === 'notEqual'
                                ? transferFilterModel.microStatus.values.includes(ele)
                                : false)
                            }
                          />
                        )
                      }
                    )}
                  </Box>
                </Box>
              </Box>
            </div>
          </>
        )}
      </Box>
      <Box sx={{ padding: '10px', display: 'none !important', }} className={`filter-dropdown-child-wrapper-v2 ${'transfer-filters-select'}`}>
        <Button
          className="date-range-wrapper__action clear-all"
          isLoading={isLoading}
          isDisabled={isLoading}
          onClick={onSaveHandler}
        >
          SAVE AS DEFAULT FILTERS
        </Button>
        <Button
          className="date-range-wrapper__action clear-all"
          isLoading={isRemoveFiltersLoading}
          isDisabled={isRemoveFiltersLoading}
          onClick={() => {
            dispatch(callToRemoveTransferFilters())
          } }
        >
          REMOVE DEFAULT FILTERS
        </Button>
      </Box>
    </>
  );
};
